

import TiwiMixin from '../../mixins/TiwiMixin';
import ModalPopup from '../ModalPopup';
import Multiselect from 'vue-multiselect'

export default {
  mixins: [TiwiMixin],
  components: {
    ModalPopup,
    Multiselect
  },
  props: {

  },
  data() {
    return {
      showModal: false,
      available_tags: [],
      interests: []
    }
  },
  mounted: function () {
    this.findAvailableTags();
  },
  methods: {
    saveInterestsData: function () {
      const self = this;

      if (this.interests.length < 1) {
        self.toast.warning('Inserisci almeno un interesse');
        return;
      }

      self.setLoading(true)
      this.api.post('users/update', { user_interests: this.interests })
        .then((response) => {
          if (response.data.success) {
            self.toast.success('Interessi utente salvati');
            // this.onSubmit(response);
            this.updateDeskUser(); // faccio la chiamata API per aggiornare su DESK i meta dell'utente
            this.showModal = false;

            // Ricarica la pagina dopo 1 secondo se tutto ok
            setTimeout(function () {
              location.reload();
            }, 1000);
          }
          else {
            self.toast.error(response.data.message);
          }
        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    },
    toggleModal: function () {
      this.showModal = !this.showModal;
    },
    addTag(newTag) {
      this.interests.push(newTag);
    },
    onClose: function () {
      this.showModal = false;
    },
    findAvailableTags(query = '') {
      this.isLoading = true;
      this.api.post('tax-query/find', { taxonomy: 'user_interests', keyword: query })
        .then((response) => {
          if (response.data.success) {
            this.available_tags = response.data.terms;
            this.isLoading = false;
          }
        })
    },
  },
  watch: {
    user(user) {
      this.interests = user.meta.interests ? user.meta.interests.map(i => i.name) : [];
    }
  }
}
